<div class="media profile-media">
  <img
    class="b-r-10"
    style="width: 40px"
    [src]="profileImg"
    alt="Foto do usuário"
  />
  <div class="media-body">
    <span>{{ userName }}</span>
    <p class="mb-0 font-roboto">
      admin <i class="middle fa fa-angle-down"></i>
    </p>
  </div>
</div>
<ul class="profile-dropdown onhover-show-div" style="width: 200px">
  <li>
    <a href="/configuracoes"
      ><app-feather-icons [icon]="'settings'"></app-feather-icons
      ><span>Configurações </span></a
    >
  </li>
  <li (click)="logoutFunc()">
    <app-feather-icons [icon]="'log-in'"></app-feather-icons><span>Sair</span>
  </li>
</ul>
